export default "__VITE_ASSET__cr_Qe8GM__"